import { IFieldServer } from "@common/redux/forms/interface";
export const emailDefaultValue: IFieldServer = {
  fieldType: "TEXT_INPUT",
  title: "Email",
  isVisible: true,
  isDisabled: false,
  isRequired: false,
  grid: {
    width: 6,
  },
  canDelete: true,
  canCopy: true,
  canAdd: true,
  type: "TEXT_INPUT",
  name: "Email",
  // localId: null,
  rules: [
    {
      rule: "EMAIL",
      errorMessage: "Enter a Valid Email",
    },
  ],
  fields: [],
  fieldConfig: {
    placeHolder: "Enter Email Id",
    isDuplicateAllowed: true,
    isPII: false,
    isQrCodeAllowed: false,
  },
};
